import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="px-10 py-20 bg-background-accent">
      <div className="container md:flex md:flex-row">
        <div className="flex-1">
          <img className="w-[120px] h-[26.5px]" src="/images/logo-with-text-primary.png" alt="countfit" />
          <address className="mt-8 leading-[1.4] text-[0.8rem] not-italic [&>span]:block text-foreground-accent">
            <h6 className="font-bold">주식회사 룸</h6>
            <span>대표이사: 오승현</span>
            <span>개인정보 책임자: 오승현</span>
            <span>사업자등록번호: 326-86-02734</span>
            <span>주소: 성남시 분당구 판교로289번길 20 판교스타트업캠퍼스 1동 8층 1호</span>
            <br />
            <span>대표전화번호: 031-548-2571</span>
            <span>고객센터: mail@countfit.ai</span>
            <span>기술지원: helpdesk@countfit.ai</span>
            <br />
            <span>Copyright ⓒ 2024 wroom inc. All rights reserved  </span>
          </address>
        </div>
        <div className="flex-1 md:block hidden" />
        <div className="md:mt-0 mt-12 flex-1 md:flex md:flex-col md:items-end">
          <div className="flex-1 flex w-full flex-row items-center">
            <a
              className="text-[0.8rem] font-bold"
              href="https://gregarious-manx-605.notion.site/ebc6c73115544acb940868f072f77472?pvs=4"
              target="_blank"
              rel="noreferrer"
            >
              사용자 이용약관
            </a>
            <span className="mx-2 w-[1px] h-[16px] bg-black block" />
            <Link className="text-[0.8rem] font-bold" to="/privacy-policy">
              개인정보 처리방침
            </Link>
          </div>
          <div className="md:mt-0 mt-8 flex-1 flex w-full flex-row gap-4">
            <div className="flex-1">
              <h6>사업제휴 및 문의</h6>
              <div className="mt-[20px] px-[20px] py-[10px] bg-white border inline-block border-foreground-accent rounded-full">
                <a href="mailto:count-fit@naver.com">문의메일 보내기</a>
              </div>
            </div>
            <div className="flex-1">
              <h6>SNS 계정</h6>
              <div className="mt-[20px] flex flex-row items-center gap-2">
                <div className="w-[48px] h-[48px]">
                  <img src="/icons/instagram-gray-icon.png" alt="INSTAGRAM" />
                </div>
                <div className="w-[48px] h-[48px]">
                  <img src="/icons/naver-gray-icon.png" alt="INSTAGRAM" />
                </div>
                <div className="w-[52px] h-[52px]">
                  <img src="/icons/kakao-gray-icon.png" alt="INSTAGRAM" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
